import { Button, Group, Select, Text } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../utils/openReport";

const DATE_TYPES = [
  { label: "Appl Received Date", value: "receivedDate" },
  { label: "Policy Received Date", value: "policyReceivedAt" },
];

const ReportFwdAb01ExpectedCommission = () => {
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [dateType, setDateType] = useState("receivedDate");

  const canDownload = Boolean(dateType && (fromDate || toDate));

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.FwdReport.getAb01ExpectedCommission({
        fromDate,
        toDate,
        dateType,
      });
      if (result?.url) {
        await openFileUrl(result.url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Text size="xs">{t("Please select the period of records.")}</Text>
      <Group mt="xs">
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder="From"
          value={fromDate}
          onChange={setFromDate}
        />
        -
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder="To"
          value={toDate}
          onChange={setToDate}
        />
        <Text size="xs">by</Text>
        <Select
          size="xs"
          value={dateType}
          data={DATE_TYPES.map((option) => ({
            ...option,
            label: t(option.label),
          }))}
          onChange={(type) => setDateType(type || "receivedDate")}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={downloadReport}
        loading={loading}
        disabled={!canDownload}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportFwdAb01ExpectedCommission;
